import { useCallback, useState } from 'react';

import { AxiosResponse } from 'axios';

import { useAxiosRequest } from '@admin/hooks';

import { createTransferRequest, regionsRequest, warehousesRequest } from './api';
import { TransferablesRegion, TransferablesWarehouse, TransferRequestForm } from './types';

export const useRegionsRequest = () => {
  const [request] = useState(() => regionsRequest());
  return useAxiosRequest<TransferablesRegion[]>(request);
};

export const useWarehousesRequest = () => {
  const [request] = useState(() => warehousesRequest());
  return useAxiosRequest<TransferablesWarehouse[]>(request);
};

/**
 * Mutation-style wrapper around useAxiosRequest (mirrors Apollo useMutation).
 *
 * const [createTransfer, { loading, response, error }] = useCreateTransferRequest();
 * createTransfer(form);
 */
export const useCreateTransferRequest = () => {
  const [request, setRequest] = useState<Promise<AxiosResponse> | undefined>();
  const { loading, response, error } = useAxiosRequest(request);

  const execute = useCallback((form: TransferRequestForm) => {
    setRequest(createTransferRequest(form));
  }, []);

  const reset = useCallback(() => {
    setRequest(undefined);
  }, []);

  return [execute, { loading, response, error, reset }] as const;
};
